import { getPrefix } from '../../core/utils/locale.js'
import { deleteCookies, readCookie } from '../../utils/cookie_manager'
import { getLazyData } from '../../utils/get_lazy_data'
import { openSessionFancybox } from '../../utils/ib_session_fancybox'

import { initializeUtagEvents } from './horizons_postregister_lightbox.analytics.js'

function cleanSymbols(value) {
  if (/[+%&]/.test(value)) {
    value = value.replace(/[+%&]/g, ' ')
  }
  return value
}

const openPostregistrationForm = function postregistration_form() {
  const auth0_postregister_form = readCookie('auth0_postregister_form')
  const user_metadata_cookie = readCookie('user_metadata')

  if (auth0_postregister_form === 'true' && user_metadata_cookie !== null) {
    try {
      const prelead_type = cleanSymbols(readCookie('prelead_type'))

      if (prelead_type && prelead_type !== null) {
        initializeUtagEvents(prelead_type)
      }

      // Asegúrate de que user_metadata_cookie no sea nulo antes de parsear
      if (user_metadata_cookie) {
        const metadataAsObject = JSON.parse(decodeURIComponent(user_metadata_cookie))
        let metadataAsUrl = ''
        for (const key in metadataAsObject) {
          metadataAsUrl += `&${key}=${encodeURIComponent(metadataAsObject[key])}`
        }
        const URL_LIGHTBOX = `${getPrefix()}/ajax_contents/lightbox_for_block/?lightbox_type=registration&postregistration=true${metadataAsUrl}`

        getLazyData(URL_LIGHTBOX, function (fancyboxHtml) {
          openSessionFancybox(fancyboxHtml, '.register form', {}, true)

          // Delete cookie when user cancels post-registration window
          const cancelPostRegister = document.querySelector('.cancel-register')

          cancelPostRegister?.addEventListener('click', () => {
            deleteCookies(['prelead_type', 'auth0_postregister_form'])
          })
        })
      }
    } catch (e) {
      console.error(`Error horizons_postregister_lightbox.js: ${e}`)

      deleteCookies(['auth0_postregister_form'])
    }
  }
}

export default openPostregistrationForm
